import { Badge, Box, Combobox, useCombobox } from '@mantine/core';

import { ComboboxOption } from 'components/combobox-option/ComboboxOption';

type Props<T> = {
    children: React.ReactNode;
    suggestions?: {
        value: string;
        internalValue?: T;
        label: string;
        default?: boolean;
    }[];
    onChange: (internalValue: T | string) => void;
};

export const FieldWithSuggestions = <T,>({ children, suggestions, onChange }: Props<T>) => {
    const combobox = useCombobox();

    if (!suggestions?.length) {
        return <>{children}</>;
    }

    return (
        <Combobox
            store={combobox}
            onOptionSubmit={(value) => {
                const option = suggestions.find((suggestion) => suggestion.value === value);

                if (option) {
                    onChange(option.internalValue ?? value);
                }

                combobox.closeDropdown();
            }}
        >
            <Combobox.Target>
                <Box onClick={() => combobox.toggleDropdown()}>{children}</Box>
            </Combobox.Target>
            <Combobox.Dropdown>
                {suggestions.map(({ value, label, default: isDefault }) => {
                    return (
                        <ComboboxOption
                            value={value}
                            key={value}
                            rightSection={
                                isDefault ? (
                                    <Badge size="sm" radius="sm">
                                        DEFAULT
                                    </Badge>
                                ) : undefined
                            }
                        >
                            {label}
                        </ComboboxOption>
                    );
                })}
            </Combobox.Dropdown>
        </Combobox>
    );
};
